<template>
  <div class="scene-list-item" :style="styleObject">
    <a
      :href="linkUrl"
      class="scene-list-item__link"
      :data-gtm-page="dataGtmPage"
      :data-gtm-click="dataGtmClick"
      :data-gtm-scene-id="dataGtmPage && dataGtmClick ? sceneId : null"
      @click="$emit('click-scene', sceneId)"
    >
      <ImgLazy
        :image-url="imageUrl"
        :alt-text="sceneName"
        aspect-ratio="16 / 9"
        class="scene-list-item__image"
      />
    </a>
  </div>
</template>
<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    sceneId: {
      type: Number,
      required: true
    },
    sceneName: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    linkUrl: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: false,
      default: '198px'
    },
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    },
    dataGtmClick: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    styleObject() {
      return {
        '--width': this.width
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.scene-list-item {
  width: var(--width);
  min-width: var(--width);
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;

  &__link {
    @extend %hover-common;
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
